import React from "react";
import "../../Styles/OrderSummary.css";

export default function OrderSummary({ plan, onBack }) {
  return (
    <section className="card">
      <h3 className="text-xl font-semibold mb-4">Order Summary</h3>

      <div className="flex items-start gap-3">
        <div className="grid h-10 w-10 place-items-center rounded-xl bg-indigo-100 text-indigo-700 text-xl">
          ⭐
        </div>
        <div>
          <div>
            <div className="font-semibold text-lg">
              {plan?.name}
              {plan?.billingCycle && (
                <span className="billing-badge text-blue-600 font-bold text-sm ml-2 inline-block transition-all duration-300 hover:text-blue-700 cursor-pointer">
                  <span className="dot-blink"></span> {plan?.billingCycle === 'YEARLY' ? 'Yearly' : 'Monthly'} Plan
                </span>
              )}
            </div>
            <div className="text-sm text-gray-600 mt-1">{plan?.description}</div>
          </div>
        </div>
      </div>

      <hr className="my-4" />

      <div className="flex justify-between text-sm">
        <span>Subtotal</span>
        <span>
          {plan?.currencySymbol}
          {Number(plan?.price).toFixed(2)}
        </span>
      </div>
      <div className="flex justify-between text-sm">
        <span>Tax</span>
        <span>$0.00</span>
      </div>

      <div className="mt-2 flex justify-between text-lg font-bold">
        <span>Total</span>
        <span>
          {plan?.currencySymbol}
          {Number(plan?.price).toFixed(2)}
        </span>
      </div>

      <div className="mt-4 rounded-md border border-emerald-200 bg-emerald-50 p-3 text-emerald-700 text-sm">
        <span className="mr-2">🔒</span>
        Your payment information is secure and encrypted
      </div>

      <button
        type="button"
        className="mt-6 w-full rounded-full border border-gray-300 py-2 text-sm text-gray-700 hover:bg-gray-50"
        onClick={onBack}
      >
        ← Back to Home
      </button>
    </section>
  );
}
